module.exports = __webpack_public_path__ + "static/img/dyson-icon.519e486f.jpg";